var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-annotation",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      error: _vm.error,
      loading: _vm.loading
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", "annotation")
      },
      "refresh-card": function($event) {
        return _vm.refreshTab(_vm.currentTab, {}, true)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function() {
            return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
          },
          proxy: true
        },
        _vm.cardData
          ? {
              key: "content",
              fn: function() {
                return [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "flex-column hp-10 annotation-tab",
                      attrs: { value: _vm.currentTab },
                      on: { "tab-click": _vm.fetchTab }
                    },
                    _vm._l(_vm.cardTypes, function(cardType, cardTypeIndex) {
                      return _c(
                        "el-tab-pane",
                        {
                          key: cardTypeIndex,
                          staticClass: "flex-column hp-10 pr-2",
                          attrs: { label: cardType.label, name: cardType.id },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "CompassTooltip",
                                          {
                                            attrs: {
                                              content: cardType.label,
                                              arrow: false
                                            }
                                          },
                                          [
                                            _c("CompassIcon", {
                                              attrs: { icon: cardType.icon }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          cardType.id == "dashboard"
                            ? _c(
                                "div",
                                [
                                  _c("RichText", {
                                    staticClass: "custom-richtext",
                                    attrs: {
                                      placeholder: _vm.$t.__(
                                        "dashboard.cards.AnnotationCard.write_something"
                                      ),
                                      options: _vm.optionsRichText
                                    },
                                    model: {
                                      value: _vm.annotation.annot_text,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.annotation,
                                          "annot_text",
                                          $$v
                                        )
                                      },
                                      expression: "annotation.annot_text"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "aright mt-2 mb-3" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "link",
                                          class:
                                            _vm.annotation.annot_text.length ==
                                            ""
                                              ? "hidden"
                                              : "",
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.save(
                                                _vm.annotation,
                                                _vm.currentTab
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$l10n.__("Enregistrer"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "annotationCard hp-10" },
                            [
                              cardType.data.length > 0
                                ? _vm._l(cardType.data, function(
                                    annotation,
                                    cardDataIndex
                                  ) {
                                    return _c("annotation", {
                                      key: cardDataIndex,
                                      attrs: {
                                        data: annotation,
                                        currentTab: _vm.currentTab
                                      },
                                      on: { "save-annotation": _vm.save }
                                    })
                                  })
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                                        staticStyle: { width: "170px" }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "/ressources/logged/img/dashboard/dashboard-comment.svg",
                                            alt: "",
                                            width: "120"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "mt-3 gray-60 acenter"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$l10n.__(
                                                    "Vous n'avez pas de commentaires"
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    }),
                    1
                  )
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }